import gameIds from 'a/hub/data/GameIds';

export const GAME_ID = gameIds.ALL_ABOARD;

export const QUESTION_COUNT_TO_CONFIRM_LOCAL = 7;
export const DESIRED_LENGTH_EXPRESS = 5;
export const DESIRED_LENGTH_LOCAL = 7;
export const CARS_NOT_INCLUDED_IN_LENGTH = 2; // ENGINE AND CABOOSE
export const MASTERY_THRESHOLD = 83.3;

export const SCREENS = {
  PROGRESS: 'PROGRESS',
  STANDARD: 'STANDARD',
  LOADING: 'LOADING',
  ONBOARDING: 'ONBOARDING',
};

export const FEEDBACK_STATES = {
  NONE: 'NONE',
  CORRECT_FIRST: 'CORRECT_FIRST',
  CORRECT_SECOND: 'CORRECT_SECOND',
  INCORRECT_FIRST: 'INCORRECT_FIRST',
  INCORRECT_SECOND: 'INCORRECT_SECOND',
};

export const ROUND_STATES = {
  FEEDBACK: 'FEEDBACK',
  QUESTION: 'QUESTION',
  NO_ACTIVE_ROUND: 'NO_ACTIVE_ROUND',
  END_OF_ROUND_RESULTS: 'END_OF_ROUND_RESULTS',
};

// Current game type, used for reporting
export const GAME_TYPE = {
  ONBOARDING: 'onboarding',
  STANDARD: 'standard',
};

export const REDUX_ACTIONS = {
  CHANGE_SCREEN: 'CHANGE_SCREEN',
  SELECT_LEVEL: 'SELECT_LEVEL',
  SELECT_ONBOARDING_LEVEL: 'SELECT_ONBOARDING_LEVEL',
  INIT_ONBOARDING: 'INIT_ONBOARDING',
  LOAD_MAZE: 'LOAD_MAZE',
  INIT_ROUND_STATE: 'INIT_ROUND_STATE',
  SELECT_CELL: 'SELECT_CELL',
  DESELECT_CELL: 'DESELECT_CELL',
  CLEAR_SELECTION: 'CLEAR_SELECTION',
  MOVE_TRAIN: 'MOVE_TRAIN',
  GROW_TRAIN: 'GROW_TRAIN',
  PROVIDE_FEEDBACK: 'PROVIDE_FEEDBACK',
  END_FEEDBACK: 'END_FEEDBACK',
  HIGHLIGHT_CELL: 'HIGHLIGHT_CELL',
  CLEAR_HIGHLIGHT: 'CLEAR_HIGHLIGHT',
  ALEX_SPEAKING: 'ALEX_SPEAKING',
  ALEX_SILENT: 'ALEX_SILENT',
  ALEX_PAUSE: 'ALEX_PAUSE',
  UPDATE_LEVEL_CONTENT: 'UPDATE_LEVEL_CONTENT',
  COMPLETE_ONBOARDING: 'COMPLETE_ONBOARDING',
  SAVE_ALEX_INSTRUCTIONS: 'SAVE_ALEX_INSTRUCTIONS',
  MARK_PASSENGER_ONBOARDING_AS_SEEN: 'MARK_PASSENGER_ONBOARDING_AS_SEEN',
  MARK_DUAL_TRACK_ONBOARDING_AS_SEEN: 'MARK_DUAL_TRACK_ONBOARDING_AS_SEEN',
  HIGHLIGHT_PATH: 'HIGHLIGHT_PATH',
  SET_IS_SPEAKER_ICON_WIGGLING: 'SET_IS_SPEAKER_ICON_WIGGLING',
  QUICK_ROUND: 'QUICK_ROUND',
  SET_SHOW_INCORRECT_FEEDBACK: 'SET_SHOW_INCORRECT_FEEDBACK',
  SET_SHOW_CORRECT_FEEDBACK: 'SET_SHOW_CORRECT_FEEDBACK',
};

export const PASSENGER_IDS = [
  'passenger0',
  'passenger1',
  'passenger2',
  'passenger5',
  'passenger6',
  'passenger7',
  'passenger8',
  'passenger9',
  'passenger10',
  'passenger11',
  'passenger12',
  'passenger13',
  'passenger14',
  'passenger15',
  'passenger16',
  'passenger17',
  'passenger18',
  'passenger19',
  'passenger20',
  'passenger21',
  'passenger22',
  'passenger23',
  'passenger24',
  'passenger25',
  'passenger26',
];
